import { Extension } from '@tiptap/core';
import {
    ChoiceNode,
    ChoiceNodeHeadless,
    ExplanationNode,
    ExplanationNodeHeadless,
    MultipleChoiceNode,
    MultipleChoiceNodeHeadless,
    QuestionNode,
    QuestionNodeHeadless,
} from './multiple-choice-extension';

export const MultipleChoiceHeadless = Extension.create({
    name: 'multipleChoiceWrapper',

    addOptions() {
        return {};
    },

    addExtensions() {
        return [MultipleChoiceNodeHeadless, QuestionNodeHeadless, ChoiceNodeHeadless, ExplanationNodeHeadless];
    },
});

export const MultipleChoice = MultipleChoiceHeadless.extend({
    addExtensions() {
        return [MultipleChoiceNode, QuestionNode, ChoiceNode, ExplanationNode];
    },
});

export default MultipleChoice;
